/* eslint-disable space-before-function-paren */
/* eslint-disable comma-dangle */
/* eslint-disable quotes */
export const API_VERSION = '/v1';
export const ALC_API_VERSION = '/v1';
export const DEV_URL = 'https://13.89.51.183:8080/'; // https://20.9.45.160:8080/'; // 'https://13.89.24.57:8080/'; // 'https://52.173.37.113:8080/'; //'https://20.29.73.136:8080/'; // 'https://40.77.42.159:8080/';
export const TEST_URL = 'https://74.249.255.217:8080/'; // 'https://20.29.84.39:8080/'; // 'https://23.100.86.35:8080/'; // 'https://52.176.42.101:8080/'; // 'https://104.43.195.17:8080/';
export const PROD_URL = 'https://20.97.114.169:8080/';
export const STAGE_URL = 'https://23.101.122.140:8080/'; // 'https://40.78.135.72:8080/'; //'https://23.99.255.154:8080/';
export const PROD_URL1 = 'https://20.97.114.169/';
export const PROD_URL2 = 'https://allocations.streamrealty.com/';
export const PROD_URL3 = 'https://allocations.streamrealty.com:8080/';

export const SSRS_DEV_URL = 'http://devazsql01/ReportServer?/Allocations/';
export const SSRS_TEST_URL = 'http://testazsql01/ReportServer?/Allocations/';
export const SSRS_PROD_URL = 'http://Prodazsql01/ReportServer?/Allocations/';
export const SSRS_STAGE_URL = 'http://stgazsql01/ReportServer?/Allocations/';

export const API_HEADERS = {
  authName: 'Bearer',
  authToken: 'msal.' + getCurrentEnvironment().clientId + '.idtoken',
  CID: 'CID',
};
export function getCurrentEnvironment() {
  let environment = 'dev';
  let clientId = '89cf3cf5-d09e-4fa7-8c90-06918eba270a';
  let isLocal = false;
  let url = DEV_URL;
  let ssrsUrl = SSRS_DEV_URL;

  if (window.location.href.indexOf(DEV_URL) >= 0) {
    environment = 'dev';
    url = DEV_URL;
    ssrsUrl = SSRS_DEV_URL;
    //  url = 'https://gs-4097:8881/';
  } else if (
    window.location.href.indexOf('gs-5501') > 0 ||
    window.location.href.indexOf('localhost') > 0
  ) {
    isLocal = true;
    environment = 'dev';
    // url = PROD_URL1;
    url = DEV_URL;
    ssrsUrl = SSRS_DEV_URL;
    // clientId = '410306f9-6559-46e0-8bf3-521e5a09759a';
    // url = 'https://gs-5182:8881/';
    // url = 'https://gs-6846:8881/';
  } else if (window.location.href.indexOf(TEST_URL) >= 0) {
    environment = 'test';
    url = TEST_URL;
    ssrsUrl = SSRS_TEST_URL;
  } else if (window.location.href.indexOf(STAGE_URL) >= 0) {
    environment = 'stage';
    clientId = '38bba079-7874-48f9-b8fc-b438b2221e88';
    url = STAGE_URL;
    ssrsUrl = SSRS_STAGE_URL;
  } else if (window.location.href.indexOf(PROD_URL) >= 0) {
    clientId = '410306f9-6559-46e0-8bf3-521e5a09759a';
    environment = 'prod';
    url = PROD_URL;
    ssrsUrl = SSRS_PROD_URL;
  } else if (window.location.href.indexOf(PROD_URL1) >= 0) {
    clientId = '410306f9-6559-46e0-8bf3-521e5a09759a';
    environment = 'prod';
    url = PROD_URL1;
    ssrsUrl = SSRS_PROD_URL;
  } else if (window.location.href.indexOf(PROD_URL2) >= 0) {
    clientId = '410306f9-6559-46e0-8bf3-521e5a09759a';
    environment = 'prod';
    url = PROD_URL2;
    ssrsUrl = SSRS_PROD_URL;
  } else if (window.location.href.indexOf(PROD_URL3) >= 0) {
    clientId = '410306f9-6559-46e0-8bf3-521e5a09759a';
    environment = 'prod';
    url = PROD_URL3;
    ssrsUrl = SSRS_PROD_URL;
  }

  return {
    environment: environment,
    isLocal: isLocal,
    clientId: clientId,
    baseUrl: url,
    ssrsUrl: ssrsUrl
  };
}
function getBaseUrl() {
  const env = getCurrentEnvironment();
  return `${env.baseUrl}api`;
}

export function getSSRSBaseUrl() {
  const env = getCurrentEnvironment();
  return `${env.ssrsUrl}`;
}

export function createApiUrl(apiName) {
  return `${getBaseUrl()}${API_VERSION}/${apiName}`;
}

export const API_URL = {
  graph: {
    userProfilePhoto: 'https://graph.microsoft.com/v1.0/me/photo/$value',
  },
  UltiProService: {
    GetWorkHoursByEmployeeId: createApiUrl('UltiProService/GetWorkHoursByEmployeeId'),
    // GetUltiProOvertimeScheduleDetails: createApiUrl('UltiProService/GetUltiProOvertimeScheduleDetails')
  },
  Market: {
    marketdata: createApiUrl('Market/GetMarketData'),
    GetMarketMasterdata: createApiUrl('Market/GetMarketListingData'),
    GetAllMarketMasterdata: createApiUrl('Market/GetAllMarketListingData'),
    GetMarketDetails: createApiUrl('Market/GetMarketDetails'),
    GetMarketCityStateMasterData: createApiUrl(
      'Market/GetMarketCityStateMasterData'
    ),
  },
  Report: {
    GetEmployeeReimbursementsBilledAmounts: createApiUrl('Report/GetEmployeeReimbursementsBilledAmounts'),
    GetMarketReimburseData: createApiUrl('Report/GetMarketReimburseData'),
    GetNewHireEmployee: createApiUrl('Report/GetNewHireEmployee'),
    GetTerminatedEmployee: createApiUrl('Report/GetTerminatedEmployee'),
    GetChangeInMarketAllocation: createApiUrl(
      'Report/GetChangeInMarketAllocation'
    ),
    GetChangeInPropertyAllocation: createApiUrl(
      'Report/GetChangeInPropertyAllocation'
    ),
    GetPropertyReimburseData: createApiUrl('Report/GetPropertyReimburseData'),
    GetPropertyAllocationSummary: createApiUrl('Report/GetPropertyAllocationSummary'),
    GetMarketAllocationSummary: createApiUrl('Report/GetMarketAllocationSummary'),
    GetPayCycle: createApiUrl('Report/GetPayCycle'),
    GetExpenseGroup: createApiUrl('Report/GetExpenseGroup'),
    GetExpenseName: createApiUrl('Report/GetExpenseName'),
    GetAccountCodeName: createApiUrl('Report/GetAccountCodeName'),
    GetReimbursementAdjustmentSummary: createApiUrl('Report/GetReimbursementAdjustmentSummary'),
    GetBillingInvoiceSummary: createApiUrl('Report/GetBillingInvoiceSummary'),
    GetDataCenterPropertyReimbursement: createApiUrl('Report/GetDataCenterPropertyReimbursement'),
    GetDataCenterPropertyVaianceData: createApiUrl('Report/GetDataCenterPropertyVaianceData'),
    GetMarketVaianceDetailData: createApiUrl('Report/GetMarketVaianceDetailData'),
    GetPTFDetailReport: createApiUrl('Report/GetPTFDetailReport')
  },
  Dashboard: {
    GetPendingActions: createApiUrl('Dashboard/GetPendingActions'),
    GetWidgetMasterListByGroup: createApiUrl(
      'DashBoard/GetWidgetMasterListByGroup'
    ),
    UpdateWidgetMaster: createApiUrl('Dashboard/UpdateWidgetMaster'),
    UpdateUserWidgetMapping: createApiUrl('Dashboard/UpdateUserWidgetMapping'),
    RemoveUserWidgetMapping: createApiUrl('Dashboard/RemoveUserWidgetMapping'),
    AddWidgetMapping: createApiUrl('Dashboard/AddUserWidgetMapping'),
    GetWidgetMasterDataList: createApiUrl('Dashboard/GetWidgetMasterDataList'),
    GetWidgetSourceData: createApiUrl('Dashboard/GetWidgetDataByDataSource'),
    GetWidgetSourceList: createApiUrl('Dashboard/GetWidgetSourceList'),
    GetPendingNotifications: createApiUrl('Dashboard/GetPendingNotifications'),
    UpdateNotificationAction: createApiUrl('Dashboard/UpdateNotificationAction'),
    // GetWidgetDataByDataSource: createApiUrl('Dashboard/GetWidgetDataByDataSource'),
    ResetUserWidgetsToDefault: createApiUrl(
      'Dashboard/ResetUserWidgetsToDefault'
    ),
    UpdateGroupWidgetMapping: createApiUrl(
      'Dashboard/UpdateGroupWidgetMapping'
    ),
    GetWidgetMasterList: createApiUrl('Dashboard/GetWidgetMasterList'),
    GetUserWidgetConfiguration: createApiUrl(
      'Dashboard/GetUserWidgetConfiguration'
    ),
  },
  Employee: {
    GetBillingAdjustmentEmployeeList: createApiUrl('Employee/GetBillingAdjustmentEmployeeList'),
    GetReimbursementAdjustmentDetail: createApiUrl('Employee/GetReimbursementAdjustmentDetail'),
    GetEmployeeDetails: createApiUrl('Employee/GetEmployeeDetails'),
    GetControllerDetail: createApiUrl('Employee/GetControllerDetail'),
    GetEmployeeData: createApiUrl('Employee/GetEmployeeData'),
    GetEmployeeMasterData: createApiUrl('Employee/GetEmployeeListingData'),
    GetDepartmentMasterData: createApiUrl('Employee/GetDepartmentListingData'),
    GetAllDepartmentMasterData: createApiUrl('Employee/GetAllDepartmentListingData'),
    GetDesignationConfiguration: createApiUrl('Employee/GetDesignationConfiguration'),
    UpdateDesignationConfiguration: createApiUrl('Employee/UpdateDesignationConfiguration'),
    GetDesignationMasterData: createApiUrl(
      'Employee/GetDesignationListingData'
    ),
    GetEmployeeSupervisorList: createApiUrl(
      'Employee/GetEmployeeSupervisorList'
    ),
    GetEmployeeOvertimeDetail: createApiUrl(
      'Employee/GetEmployeeOvertimeDetail'
    ),
    GetPendingEmployeeOvertimeDetail: createApiUrl(
      'Employee/GetPendingEmployeeOvertimeDetail'
    ),
    GetEmployeeListBySupervisor: createApiUrl(
      'Employee/GetEmployeeListBySupervisor'
    ),
    UpdateOverTimeEmployee: createApiUrl(
      'Employee/UpdateOverTimeEmployee'
    ),
    SaveEmployeeOvertime: createApiUrl('Employee/SaveEmployeeOvertime'),
    GetEmployeeOtHours: createApiUrl(
      'Employee/GetEmployeeOtHours'
    ),
    SaveReimbursementAdjustment: createApiUrl('Employee/SaveReimbursementAdjustment'),
    GetUltiProOvertimeScheduleDetails: createApiUrl('Employee/GetUltiProOvertimeScheduleDetails'),
    GetEmployeeBonusEstimation: createApiUrl(
      'Employee/GetEmployeeBonusEstimation'
    ),
    UpdateEmployeeBonusEstimation: createApiUrl(
      'Employee/UpdateEmployeeBonusEstimation'
    ),
    GetEmployeeBonusAccrual: createApiUrl(
      'Employee/GetEmployeeBonusAccrual'
    ),
    UpdateEmployeeBonusAccrual: createApiUrl(
      'Employee/UpdateEmployeeBonusAccrual'
    ),
    GetEmployeeInformation: createApiUrl(
      'Employee/GetEmployeeInformations'
    ),
  },
  Allocation: {
    GetAllocationData: createApiUrl('Allocation/GetAllocationData'),
    UpdateAllocation: createApiUrl('Allocation/UpdateAllocation'),
    UpdateMultipleAllocation: createApiUrl(
      'Allocation/UpdateMultipleAllocation'
    ),
    GetAllFlatTypeRate: createApiUrl('Allocation/GetAllFlatTypeRate'),
    DeleteAllocation: createApiUrl('Allocation/DeleteAllocation'),
    GetPreBillingData: createApiUrl('Allocation/GetVarianceAnalysisData'),
    GetApprovalStatus: createApiUrl('Allocation/GetApprovalStatus'),
    GetDivisions: createApiUrl('Allocation/GetDivisions'),
    GetPayPeriod: createApiUrl('Allocation/GetPayPeriod'),
    ClosePayPeriod: createApiUrl('Allocation/ClosePayPeriod'),
    UpdateAllocationComplianceDetail: createApiUrl('Allocation/UpdateAllocationComplianceDetail'),
    GetAllocationComplianceDetail: createApiUrl('Allocation/GetAllocationComplianceDetail'),
    GetComplianceStatus: createApiUrl('Allocation/GetComplianceStatus'),
  },
  Assignments: {
    GetAssignmentsData: createApiUrl('Assignment/GetAssignmentData'),
    GetServiceTypeMasterData: createApiUrl(
      'Assignment/GetServiceTypeMasterData'
    ),
    GetAssignmentDetails: createApiUrl('Assignment/GetAssignmentDetails'),
    UpdateAssignment: createApiUrl('Assignment/UpdateAssignment'),
    InsertAssignment: createApiUrl('Assignment/InsertAssignment'),
  },
  Property: {
    GetPropertyDetails: createApiUrl('Property/GetPropertyDetails'),
    GetPropertyData: createApiUrl('Property/GetPropertyData'),
    GetPropertyMasterData: createApiUrl('Property/GetPropertyListingData'),
    GetPropertyTypeMasterData: createApiUrl(
      'Property/GetPropertyTypeListingData'
    ),
    GetPropertyLegalEntity: createApiUrl('Property/GetPropertyLegalEntity'),
    GetExpenseType: createApiUrl('Property/GetPropertyExpenseType'),
    GetPropertyList: createApiUrl('Property/GetPropertyList'),
    GetPropertySubType: createApiUrl('Property/GetPropertySubType'),
    UpdatePropertyField: createApiUrl('Property/UpdatePropertyField'),
    GetPropertyTenantCount: createApiUrl('Property/GetPropertyTenantCount'),
    UpdatePropertyTenantCount: createApiUrl('Property/UpdatePropertyTenantCount'),
    UpdatePropertyTenantMapping: createApiUrl('Property/UpdatePropertyTenantMapping'),
    GetUnmappedARAdminProperty: createApiUrl('Property/GetUnmappedARAdminProperty'),
  },

  // },
  Json: {
    GetYearEndBonusReport: createApiUrl('Json/GetYearEndBonusReport'),
    GetARReimbursementCost: createApiUrl('Json/GetARReimbursementCost'),
    GetReportConfiguration: createApiUrl('Json/GetReportConfiguration'),
    GetRptUnmappedReports: createApiUrl('Json/GetRptUnmappedReports'),

  },
  Users: {
    sendComplianceReminderEmail: createApiUrl('Users/SendComplianceReimderEmail'),
    GetAccessGroups: createApiUrl('Users/GetAccessGroups'),
    GetPermissionByGroup: createApiUrl('Users/GetPermissionByGroup'),
    UpdatePermission: createApiUrl('Users/UpdatePermission'),
    GetServiceTypeEmailMappingData: createApiUrl(
      'Users/GetServiceTypeEmailMapping'
    ),
    UpdateServiceTypeEmail: createApiUrl('Users/UpdateServiceTypeEmail'),
    UpdateServiceTypeEmailTemplate: createApiUrl(
      'Users/UpdateServiceTypeEmailTemplate'
    ),
    GetServiceTypeDepartmentConfig: createApiUrl(
      'Users/GetServiceTypeDepartmentConfig'
    ),
    UpdateServiceTypeDepartmentConfiguration: createApiUrl(
      'Users/UpdateServiceTypeDepartmentConfiguration'
    ),
    GetExpenseGroupPayCodeMapping: createApiUrl('Users/GetExpenseGroupPayCodeMapping'),
    UpdatePayCodeDetail: createApiUrl('Users/UpdatePayCodeDetail'),
    GetBurdenMasterData: createApiUrl('Users/GetAllBurdenRate'),
    GetBurdenRateByDepartement: createApiUrl(
      'Users/GetBurdenRateByDepartement'
    ),
    UpdateBurdenRateDepartment: createApiUrl(
      'Users/UpdateBurdenRateDepartment'
    ),
    GetDesignationThresholdData: createApiUrl(
      'Users/GetDesignationThresholdConfiguration'
    ),
    UpdateDesignationThresholdData: createApiUrl(
      'Users/UpdateDesignationThresholdConfiguration'
    ),
    GetUserOrganizationDetails: createApiUrl(
      'Users/GetUserOrganizationDetails'
    ),
    GetUserConfigurations: createApiUrl('Users/GetUserConfigurations'),
    GetAccessType: createApiUrl('Users/GetAccessType'),
    GetAllMarketAccessPermission: createApiUrl('Users/GetAllMarketAccessPermission'),
    InsertMarketAccessPermission: createApiUrl('Users/InsertMarketAccessPermission'),
    AcquireSPToken: createApiUrl('Users/AcquireSPToken'),
    GetPaycode: createApiUrl('Users/GetPaycode'),
    GetPaycodeType: createApiUrl('Users/GetPaycodeType'),
    GetServiceTypePaycode: createApiUrl('Users/GetServiceTypePaycode'),
    UpdateServiceTypePayCodeConfiguration: createApiUrl('Users/UpdateServiceTypePayCodeConfiguration'),
    GetPropertyAccountingPayroll: createApiUrl('Users/GetPropertyAccountingPayroll'),
    GetDatacenterPayroll: createApiUrl('Users/GetDatacenterPayroll'),
    UpdatePropertyAccountingPayrollConfiguration: createApiUrl('Users/UpdatePropertyAccountingPayrollConfiguration'),
    GetDatacenterPropertyConfiguration: createApiUrl('Users/GetDatacenterPropertyConfiguration'),
    UpdateGetDatacenterPropertyConfiguration: createApiUrl('Users/UpdateDatacenterPropertyConfiguration'),
    UpdateDatacenterPayrollConfiguration: createApiUrl('Users/UpdateDatacenterPayrollConfiguration'),
    GetSDCBudgetedPercentConfiguration: createApiUrl(
      'Users/GetSDCBudgetedPercentConfiguration'
    ),
    UpdateSDCBudgetedPercentConfiguration: createApiUrl(
      'Users/UpdateSDCBudgetedPercentConfiguration'
    ),
    GetPmaTitles: createApiUrl(
      'Users/GetPmaTitles'
    ),
    GetSDCDesignationTitleConfiguration: createApiUrl(
      'Users/GetSDCDesignationTitleConfiguration'
    ),
    UpdateSDCDesignationTitleConfiguration: createApiUrl(
      'Users/UpdateSDCDesignationTitleConfiguration'
    ),
    GetDatacenterEmployeeBonusConfiguration: createApiUrl(
      'Users/GetDatacenterEmployeeBonusConfiguration'
    ),
    UpdateDatacenterEmployeeBonusConfiguration: createApiUrl(
      'Users/UpdateDatacenterEmployeeBonusConfiguration'
    ),
    GetDesignationBonus: createApiUrl('Users/GetDesignationBonus'),
    UpdateYearEndBonusDesignationConfiguration: createApiUrl('Users/UpdateYearEndBonusDesignationConfiguration'),
    UpdateYearEndComplianceStatus: createApiUrl('Users/UpdateYearEndComplianceStatus'),
    GetYearEndComplianceStatus: createApiUrl('Users/GetYearEndComplianceStatus'),
    GetYearEndBonusConfiguration: createApiUrl('Users/GetYearEndBonusConfiguration'),
    SendYearEndBonusComplianceReminderEmail: createApiUrl('Users/SendYearEndBonusComplianceReminderEmail'),
    CloseYearEndBonus: createApiUrl('Users/CloseYearEndBonus'),
    UpdateARAdminPropertyMapping: createApiUrl('Users/UpdateARAdminPropertyMapping'),
    GetARAdminPropertyMapping: createApiUrl('Users/GetARAdminPropertyMapping'),
    GetPayrollConfigurationType: createApiUrl('Users/GetPayrollConfigurationType'),
    GetAccessPermissionTerms: createApiUrl('Users/GetAccessPermissionTerms'),
    UploadEmployeeBonusByTitle: createApiUrl('Users/UploadEmployeeBonusByTitle'),
    UploadOvertimeTimesheet: createApiUrl('Users/UploadOvertimeTimesheet'),
    UpdateAutoRunPageStatus: createApiUrl('Users/UpdateAutoRunPageStatus')
  },

  Transition: {
    GetTransitionData: createApiUrl('Transition/GetTransitionData'),
    GetSourceAccounting: createApiUrl('Transition/GetSourceAccounting'),
    UpdatePropertyCode: createApiUrl('Transition/UpdatePropertyCode'),
    UpdatePTFStatus: createApiUrl('Transition/UpdatePTFStatus'),
    GetTransitionTypeListingData: createApiUrl(
      'Transition/GetTransitionTypeListingData'
    ),
    GetPropertyLandlordDetails: createApiUrl(
      'Transition/GetPropertyLandlordDetails'
    ),
    GetClientContactDetails: createApiUrl('Transition/GetClientContactDetails'),
    GetAllClient: createApiUrl('Transition/GetAllClient'),
    GetClientListingData: createApiUrl('Transition/GetClientListingData'),
    GetClientDetail: createApiUrl('Transition/GetClientDetail'),
    CheckDuplicate: createApiUrl('Transition/CheckDuplicate'),
    GetCustomerListingData: createApiUrl('Transition/GetCustomerListingData'),
    GetTransitionDetails: createApiUrl('Transition/GetTransitionDetails'),
    GetPropertyTransitionTrackerStep: createApiUrl(
      'Transition/GetPropertyTransitionTrackerStep'
    ),
    InsertPropertyTransitionTracker: createApiUrl(
      'Transition/InsertPropertyTransitionTracker'
    ),
    UpdatePropertyTransitionTracker: createApiUrl(
      'Transition/UpdatePropertyTransitionTracker'
    ),
    InsertTransition: createApiUrl('Transition/InsertTransition'),
    UpdateTransition: createApiUrl('Transition/UpdateTransition'),
    SendPTFEmailNotification: createApiUrl('Transition/SendPTFEmailNotification'),
    UpdateClient: createApiUrl('Transition/UpdateClient'),
    UpdateServiceExtendedDate: createApiUrl('Transition/UpdateServiceExtendedDate')
  },
};
